import router from '../../router'
import axios from 'axios'
import dayjs from "dayjs";

const cidInitiatorsUrl = (rootState) =>
    rootState.surfaceUrl + `/v2/cids/${rootState.currentClient.cid}/initiators`;

const cidInitiatorFieldsUrl = (rootState) =>
    rootState.surfaceUrl + `/v2/cids/${rootState.currentClient.cid}/initiator_fields`;

const tagTemplateWritePayload = (tagTemplate) => {
    const payload = {...tagTemplate};
    delete payload.initiator_fields;
    delete payload.created_at;
    return payload;
};

// Client scoped records shadow the global ones they collide on, so a client can
// customise an initiator aqfer already ships without losing the rest of the list.
const mergeInitiatorRecords = (global, cid, key) => {
    const merged = [...(global || [])];
    (cid || []).forEach((record) => {
        const index = merged.findIndex((item) => item[key] === record[key]);
        if (index >= 0) merged.splice(index, 1, record);
        else merged.push(record);
    });
    return merged;
};

const store = {
    namespaced:true,
    state: {
        autClientData: null,
        autProdClientData: null,
        currentClass: {},
        currentClassData: null,
        deploymentStatus: null,
        countries: null, 
        domainList: [],
        currentEdgeHostNameObj: {},
        tagTemplates: [],
        publicTagTemplates: [],
        initiatorFields: [],
        initiators: [],
        cidInitiatorFields: [],
        cidInitiators: [],
        privacySignals:[],
        privacyConfig:[],
        usageData: {},
        usageDataStartDate: dayjs().startOf('month').format("YYYY-MM-DD"),
        usageDataEndDate: dayjs().format("YYYY-MM-DD"),
        usageMonth: dayjs().format('MM'),
        listCertTrigger: true,
        getCertStatusTrigger: true,
        deleteCertTrigger: true,
        renewCertTrigger: true,
    },
    mutations: {
        setAutClientData(state, data) {
            state.autClientData = data;
        },
        setAutProdClientData(state, data) {
            state.autProdClientData = data;
        },
        setCurrentClass(state, data) {
            state.currentClass[data.cid] = data.cls;
        },
        setCurrentClassData(state, data) {
            state.currentClassData = data;
        },
        setDeploymentStatus(state, data) {
            state.deploymentStatus = data;
        },
        setCountries(state, data) {
            state.countries = data;
        },
        setDomainList(state, data) {
            state.domainList = data;
        },
        setCurrentEdgeHostNameObj(state, data) {
            state.currentEdgeHostNameObj = data;
        },
        setTagTemplates(state, data) {
            state.tagTemplates = data;
        },
        setPublicTagTemplates(state, data) {
            state.publicTagTemplates = data;
        },
        setInitiatorFields(state, data) {
            state.initiatorFields = data;
        },
        setInitiators(state, data) {
            state.initiators = data;
        },
        setCidInitiatorFields(state, data) {
            state.cidInitiatorFields = data;
        },
        setCidInitiators(state, data) {
            state.cidInitiators = data;
        },
        setPrivacySignals(state, data) {
            state.privacySignals = data;
        },
        setPrivacyConfig(state, data){
            state.privacyConfig = data
        },
        setUsageData(state, data) {
            state.usageData = data
        },
        setUsageDataStartDate(state, startDate) {
            state.usageDataStartDate = startDate
        },
        setUsageDataEndDate(state, endDate) {
            state.usageDataEndDate = endDate
        },
        setUsageMonth(state, month) {
            state.usageMonth = month
        },
    },

    actions: {
        async fetchClient({rootState, state, commit}) {
            return axios.get(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}?detail=pixel`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchAutClientData({rootState, state, commit}) {
            return axios.get(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}?detail=pixel`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setAutClientData', response.data);
            }).catch((err) =>{
                commit('setAutClientData', null); 
            });
        },

        async fetchAutProdClientData({rootState, state, commit}) {
            return axios.get(rootState.autMgmtUrl + `/v1/production/clients/${rootState.currentClient.cid}?detail=pixel`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setAutProdClientData', response.data);   
            }).catch((err) =>{
                commit('setAutProdClientData', null); 
            })
        },

        onClientChange({commit}) {
            commit('setTagTemplates', [])
            commit('setDomainList', [])
            commit('setCidInitiators', [])
            commit('setCidInitiatorFields', [])
            commit('setAutClientData', {});
        },

        setAutClassData({ commit }, data) {            
            commit('setCurrentClassData', data);
        },
        setDeploymentStatus({ commit }, data) {            
            commit('setDeploymentStatus', data);
        },

        setCurrentClass({ rootState, commit }, cls) {            
            commit('setCurrentClass', {cid:rootState.currentClient.cid, cls});
        },
        setCurrentEdgeHostNameObj( { commit }, data){
            commit('setCurrentEdgeHostNameObj', data);  
        },
        setUsageData({commit}, data) {
            commit('setUsageData', data)
        },
        setUsageDataStartDate({commit}, startDate) {
            commit('setUsageDataStartDate', startDate)
        },
        setUsageDataEndDate({commit}, endDate) {
            commit('setUsageDataEndDate', endDate)
        },
        setUsageMonth({commit}, month) {
            commit('setUsageMonth', month)
        },
        async fetchUsageData({ rootState, dispatch, state, commit }, usageType) {
            commit('setUsageData', {
                ...state.usageData,
                [usageType]: {}
            });

            let payload = {
                startDate: state.usageDataStartDate,
                endDate: state.usageDataEndDate,
                product: 'aut',
                usageType: usageType
            };

            const data = await dispatch('usage/getProductUsage', payload, { root: true });

            if (data && data[payload.product]) {
                commit('setUsageData', {
                    ...state.usageData,
                    [usageType]: data[payload.product]
                });
            }

            return data;

        },
        fetchAutClassData({rootState, state, commit}, cls) {
            axios.get(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/classes/${cls}?detail=pixel`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setCurrentClass', {cid:rootState.currentClient.cid, cls});
                commit('setCurrentClassData', response.data);  
            });
        },
        
        fetchDeploymentStatus({rootState, state, commit}) {
            axios.get(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/deployment/status`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setDeploymentStatus', response.data);             
                                
            });
        },
        fetchCountries({rootState, state, commit}) {
            axios.get(rootState.autMgmtUrl + `/v1/countries`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setCountries', response.data.countries);  
            });
        },    
        fetchTagTemplates({rootState, state, commit}, filters) {
            const params = new URLSearchParams();
            if (filters?.category) params.set("category", filters.category);
            if (filters?.date) params.set("date", filters.date);
            if (filters?.fieldSearch && Object.keys(filters.fieldSearch).length) {
                params.set("field_search", JSON.stringify(filters.fieldSearch));
            }
            const query = params.toString() ? `?${params.toString()}` : "";
            return axios.get(rootState.surfaceUrl + `/v2/cids/${rootState.currentClient.cid}/tag_templates${query}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setTagTemplates', response.data);  
            });
        },
        fetchPublicTagTemplates({rootState, state, commit}) {
            axios.get(rootState.defaultSurfaceUrl + `/v2/cids/${rootState.currentClient.cid}/tag_templates?public=true`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setPublicTagTemplates', response.data);  
            });
        },   
        fetchInitiatorFields({rootState, state, commit},initiator) {
            initiator = (initiator!=undefined?"?initiator="+initiator:"")
            return axios.get(rootState.defaultSurfaceUrl + `/v2/initiator_fields`+initiator, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setInitiatorFields', response.data);
                return response;
            });
        },          
        async updateAutClientData({rootState}, payload) {
            return await axios({
                method: 'put',
                url: rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}`,
                data: payload, 
                headers: { 'Authorization': 'Bearer ' + rootState.accessToken }
            }); 
        },
        async createAutClientClass({rootState}, payload) {
            return axios({
                method: 'post',
                url: rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/classes`,
                data: payload, 
                headers: { 'Authorization': 'Bearer ' + rootState.accessToken }
            }); 
        },
        async updateAutClientClass({rootState}, payload) {
            return axios({
                method: 'put',
                url: rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/classes/${payload.cls}`,
                data: payload.classObject, 
                headers: { 'Authorization': 'Bearer ' + rootState.accessToken }
            }); 
        },
        async deleteAutClientClass({rootState}, payload) {
            return axios({
                method: 'delete',
                url: rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/classes/${payload.cls}`,
                headers: { 'Authorization': 'Bearer ' + rootState.accessToken }
            }); 
        },
        async activateClientConfig({rootState}) {
            return axios({
                method: 'post',
                url: rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/activate`,
                data: {}, 
                headers: { 'Authorization': 'Bearer ' + rootState.accessToken }
            }); 
        },

        async getDomainLists({rootState,commit}) {
            return axios.get(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/domainlists`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setDomainList', response.data); 
                return response; 
            });
        },

        async getDomainListObject({rootState, commit},edgeHostName) {
            return axios.get(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/domainlists/${edgeHostName}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                response.data.eTag = response.headers['etag']
                commit('setCurrentEdgeHostNameObj', response.data);
                return response;
            });
        },

        async createDomainLists({rootState,commit}) {
            axios.post(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/domainlists`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setDomainList', response.data);  
            });
        },

        async updateEdgeHostname({rootState}, { payload, validate=false, validationMethod=null}) {
            const eTag = payload.eTag
            delete payload.eTag
            const query = [];
            if (validate) query.push('validate=true');
            if (validationMethod) query.push(`validationMethod=${encodeURIComponent(validationMethod)}`);
            const qs = query.length ? `?${query.join('&')}` : '';
            const headers = { 'Authorization': 'Bearer ' + rootState.accessToken }
            if (eTag) {
                headers['If-Match'] = eTag
            }
            return axios({
                method: 'put',
                url: rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/domainlists/${payload.edgeHostname}${qs}`,
                data: payload,
                headers,
            });
        },

        async createTagTemplate({rootState}, tagTemplatePayload) {
            const isPublic = tagTemplatePayload.public?'?public=true':''
            return axios.post(rootState.surfaceUrl + `/v2/cids/${rootState.currentClient.cid}/tag_templates${isPublic}`, tagTemplateWritePayload(tagTemplatePayload), {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readTagTemplate({rootState}, name) {
            return axios.get(rootState.surfaceUrl + `/v2/cids/${rootState.currentClient.cid}/tag_templates/${name}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readPublicTagTemplate({rootState}, id) {
            return axios.get(rootState.surfaceUrl + `/v2/cids/${rootState.currentClient.cid}/tag_templates/${name}?public=true`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updateTagTemplate({rootState}, tagTemplatePayload) {
            return axios.put(rootState.surfaceUrl + `/v2/cids/${rootState.currentClient.cid}/tag_templates/${tagTemplatePayload.name}`, tagTemplateWritePayload(tagTemplatePayload), {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        //Note: duplicating re-reads the source so the copy carries the full template
        //body (user defined fields, notes, ...) even when it was picked off the list view,
        //where the API only returns the summary columns.
        async copyTagTemplate({rootState, dispatch}, {name, newName}) {
            const payload = (await dispatch('readTagTemplate', name)).data;
            //Server managed fields must not be carried over to the new template.
            delete payload.id;
            delete payload.created_at;
            delete payload.initiator_fields;
            delete payload.created_by;
            delete payload.modified_at;
            delete payload.modified_by;
            payload.name = newName;
            payload.owner = rootState.currentUser.email;
            payload.cid = rootState.currentClient.cid;
            //A duplicate always lands in the client's own library, never the public one.
            payload.public = false;
            payload.recommended = false;
            payload.tag = payload.tag ? payload.tag.toString() : "";
            return dispatch('createTagTemplate', payload);
        },
        async deleteTagTemplate({rootState}, tagTemplatePayload) {
            return axios.delete(rootState.surfaceUrl + `/v2/cids/${rootState.currentClient.cid}/tag_templates/` + tagTemplatePayload.name, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchInitiatorField({rootState}, name) {
            return axios.get(rootState.defaultSurfaceUrl + `/v2/initiator_fields/${name}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async createInitiatorField({rootState}, initiatorPayload) {
            return axios.post(rootState.defaultSurfaceUrl + `/v2/initiator_fields`, initiatorPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readInitiatorField({rootState}, name) {
            return axios.get(rootState.defaultSurfaceUrl + `/v2/initiator_fields/${name}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updateInitiatorField({rootState}, initiatorPayload) {
            return axios.put(rootState.defaultSurfaceUrl + `/v2/initiator_fields/${initiatorPayload.name}`, initiatorPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteInitiatorField({rootState}, initiatorPayload) {
            return axios.delete(rootState.defaultSurfaceUrl + `/v2/initiator_fields/` + initiatorPayload.name, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchInitiators({rootState, commit}) {
            return axios.get(rootState.defaultSurfaceUrl + `/v2/initiators`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setInitiators', response.data);
                return response;
            });
        },
        async createInitiator({rootState}, initiatorPayload) {
            return axios.post(rootState.defaultSurfaceUrl + `/v2/initiators`, initiatorPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async readInitiator({rootState}, name) {
            return axios.get(rootState.defaultSurfaceUrl + `/v2/initiators/${name}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updateInitiator({rootState}, initiatorPayload) {
            return axios.put(rootState.defaultSurfaceUrl + `/v2/initiators/${initiatorPayload.name}`, initiatorPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteInitiator({rootState}, initiatorPayload) {
            return axios.delete(rootState.defaultSurfaceUrl + `/v2/initiators/` + initiatorPayload.name, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchCidInitiators({rootState, commit}) {
            return axios.get(cidInitiatorsUrl(rootState), {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setCidInitiators', response.data || []);
                return response;
            });
        },
        async readCidInitiator({rootState}, name) {
            return axios.get(cidInitiatorsUrl(rootState) + `/${encodeURIComponent(name)}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async createCidInitiator({rootState}, initiatorPayload) {
            return axios.post(cidInitiatorsUrl(rootState), initiatorPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updateCidInitiator({rootState}, initiatorPayload) {
            return axios.put(cidInitiatorsUrl(rootState) + `/${encodeURIComponent(initiatorPayload.name)}`, initiatorPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteCidInitiator({rootState}, initiatorPayload) {
            return axios.delete(cidInitiatorsUrl(rootState) + `/${encodeURIComponent(initiatorPayload.name)}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchCidInitiatorFields({rootState, commit}, initiator) {
            const query = initiator != undefined ? "?initiator=" + encodeURIComponent(initiator) : "";
            return axios.get(cidInitiatorFieldsUrl(rootState) + query, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setCidInitiatorFields', response.data || []);
                return response;
            });
        },
        async readCidInitiatorField({rootState}, name) {
            return axios.get(cidInitiatorFieldsUrl(rootState) + `/${encodeURIComponent(name)}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async createCidInitiatorField({rootState}, initiatorPayload) {
            return axios.post(cidInitiatorFieldsUrl(rootState), initiatorPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updateCidInitiatorField({rootState}, initiatorPayload) {
            return axios.put(cidInitiatorFieldsUrl(rootState) + `/${encodeURIComponent(initiatorPayload.name)}`, initiatorPayload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteCidInitiatorField({rootState}, initiatorPayload) {
            return axios.delete(cidInitiatorFieldsUrl(rootState) + `/${encodeURIComponent(initiatorPayload.name)}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        // Loads the global and the client scoped initiators so that any picker can
        // offer both. A client without cid initiators (or a user without access to
        // them) still gets the global list.
        async fetchAllInitiators({dispatch, getters}) {
            await Promise.all([
                dispatch('fetchInitiators'),
                dispatch('fetchCidInitiators').catch(() => {}),
            ]);
            return getters.allInitiators;
        },
        // A client that has defined its own fields for an initiator uses only those;
        // otherwise the global ones apply. Returned rather than committed so that it
        // does not clobber the management pages' lists.
        async fetchAllInitiatorFields({rootState}, initiator) {
            const query = initiator != undefined ? "?initiator=" + encodeURIComponent(initiator) : "";
            const headers = { Authorization: `Bearer ${rootState.accessToken}` };
            const [global, cid] = await Promise.all([
                axios.get(rootState.defaultSurfaceUrl + `/v2/initiator_fields` + query, { headers })
                    .then((response) => response.data || [])
                    .catch(() => []),
                axios.get(cidInitiatorFieldsUrl(rootState) + query, { headers })
                    .then((response) => response.data || [])
                    .catch(() => []),
            ]);
            return cid.length ? cid : global;
        },
        fetchPrivacySignals({rootState, commit}) {
            axios.get(rootState.autMgmtUrl + `/v1/us_multi_state_privacy_signals`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setPrivacySignals', response.data);             
                                
            });
        },
        fetchPrivacyConfig({rootState, commit}, cid) {
            axios.get(rootState.autMgmtUrl + `/v1/staging/clients/${cid}/us_multi_state_privacy_config`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                commit('setPrivacyConfig', response.data);             
                                
            });
        },
        async addPrivacyConfig({rootState}, payload) {
            return axios.post(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/us_multi_state_privacy_config`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updatePrivacyConfig({rootState}, payload) {
            return axios.put(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/us_multi_state_privacy_config/${payload.name}`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deletePrivacyConfig({rootState}, name) {
            return axios.delete(rootState.autMgmtUrl + `/v1/staging/clients/${rootState.currentClient.cid}/us_multi_state_privacy_config/${name}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getMetricMetadata({rootState}, metric) {
            let qp = metric ? `?metric_name=${metric}` : ""
            return axios.get(rootState.countsUrl + `/v2/metrics` + qp, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`
                },
            })
        },
        async fetchCertificates({rootState}) {
            return axios.get(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchCertificate({rootState}, commonName) {
            return axios.get(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async createCertificate({rootState}, certificate) {
            return axios.post(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments`, certificate, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async updateCertificate({rootState}, certificate) {
            return axios.put(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${certificate.commonName}`, certificate, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteCertificate({rootState}, commonName) {
            return axios.delete(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getCertificateDeploymentStatus({rootState}, commonName) {
            return axios.get(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}/change`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async acknowledgeDenyWarnings({rootState}, {commonName, payload}) {
            return axios.put(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}/change/warnings_ack`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getCertificateCSR({rootState}, commonName) {
            return axios.get(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}/csr`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async createSignedCertificate({rootState}, {commonName, payload}) {
            return axios.post(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}/signed_certificate`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async getCertificateExpiry({rootState}, commonName) {
            return axios.get(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}/expiry`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async renewCertificate({rootState}, {commonName, payload}) {
            return axios.put(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}/renew`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async cancelCertificate({rootState}, commonName) {
            return axios.post(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/enrollments/${commonName}/change/abort`, {}, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async checkCaaExitstence({rootState}, domain) {
            return axios.get(rootState.autMgmtUrl + `/v1/domainlists/${domain}/caa`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async fetchAutCredentials({rootState}) {
            return axios.get(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/credentials`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async createAutCredential({rootState}, payload) {
            return axios.post(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/credentials`, payload, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
        async deleteAutCredentials({rootState}, saltId) {
            return axios.delete(rootState.autMgmtUrl + `/v1/clients/${rootState.currentClient.cid}/credentials/${saltId}`, {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            })
        },
    },

    getters: {
        // Global initiators overlaid with the current client's own initiators.
        allInitiators(state) {
            return mergeInitiatorRecords(state.initiators, state.cidInitiators, "value");
        },
        // Picker entries for every initiator available to the current client. Where an
        // initiator comes from ("aqfer" for the shared ones, the cid for the client's
        // own) is only spelled out when it would otherwise be ambiguous: another entry
        // shares the name, or a client initiator has taken over an aqfer one's value.
        initiatorOptions(state, getters, rootState) {
            const cid = rootState.currentClient ? rootState.currentClient.cid : "";
            const cidValues = new Set(state.cidInitiators.map((initiator) => initiator.value));
            const globalValues = new Set(state.initiators.map((initiator) => initiator.value));
            const initiators = getters.allInitiators;
            const nameCount = initiators.reduce((counts, initiator) => {
                counts[initiator.name] = (counts[initiator.name] || 0) + 1;
                return counts;
            }, {});
            return initiators.map((initiator) => {
                const isClientOwned = !!initiator.cid || cidValues.has(initiator.value);
                const source = isClientOwned ? (initiator.cid || cid) : "aqfer";
                const ambiguous = nameCount[initiator.name] > 1
                    || (isClientOwned && globalValues.has(initiator.value));
                return {
                    ...initiator,
                    source,
                    sourceLabel: ambiguous ? source : null,
                    label: ambiguous ? `${initiator.name} (${source})` : initiator.name,
                };
            });
        },
    }

}

export default store